var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _vm.checkPermi(["platform:lifeVibesPoint:list"])
        ? _c(
            "el-card",
            {
              staticClass: "ivu-mt",
              attrs: {
                bordered: false,
                shadow: "never",
                "body-style": { padding: 0 },
              },
            },
            [
              _c(
                "div",
                { ref: "tableheader", staticClass: "padding-add" },
                [
                  _c(
                    "el-form",
                    {
                      ref: "searchForm",
                      attrs: {
                        inline: "",
                        size: "small",
                        model: _vm.searchForm,
                        "label-width": "88px",
                        "label-position": "right",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "search-form" },
                        [
                          _c(
                            "div",
                            { staticClass: "search-form-box" },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "关键词：" } },
                                [
                                  _c("el-input", {
                                    staticStyle: { width: "220px" },
                                    attrs: {
                                      placeholder: "请输入点位/标签/地址",
                                      clearable: "",
                                    },
                                    nativeOn: {
                                      keyup: function ($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        ) {
                                          return null
                                        }
                                        return _vm.handleSearch($event)
                                      },
                                    },
                                    model: {
                                      value: _vm.searchForm.keywords,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.searchForm,
                                          "keywords",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "searchForm.keywords",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                { attrs: { label: "点位类型：" } },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "180px" },
                                      attrs: {
                                        clearable: "",
                                        placeholder: "请选择点位类型",
                                      },
                                      model: {
                                        value: _vm.searchForm.pointType,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.searchForm,
                                            "pointType",
                                            $$v
                                          )
                                        },
                                        expression: "searchForm.pointType",
                                      },
                                    },
                                    _vm._l(
                                      _vm.pointTypeOptions,
                                      function (item) {
                                        return _c("el-option", {
                                          key: item.value,
                                          attrs: {
                                            label: item.label,
                                            value: item.value,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                { attrs: { label: "所在地区：" } },
                                [
                                  _c("el-cascader", {
                                    staticStyle: { width: "280px" },
                                    attrs: {
                                      options: _vm.regionOptions,
                                      props: _vm.regionProps,
                                      clearable: "",
                                      filterable: "",
                                      placeholder: "请选择省/市/区",
                                    },
                                    on: { change: _vm.handleRegionChange },
                                    model: {
                                      value: _vm.selectedRegion,
                                      callback: function ($$v) {
                                        _vm.selectedRegion = $$v
                                      },
                                      expression: "selectedRegion",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                { attrs: { label: "附近经度：" } },
                                [
                                  _c("el-input", {
                                    staticStyle: { width: "140px" },
                                    attrs: {
                                      placeholder: "可选",
                                      clearable: "",
                                    },
                                    model: {
                                      value: _vm.searchForm.lng,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.searchForm,
                                          "lng",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "searchForm.lng",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                { attrs: { label: "附近纬度：" } },
                                [
                                  _c("el-input", {
                                    staticStyle: { width: "140px" },
                                    attrs: {
                                      placeholder: "可选",
                                      clearable: "",
                                    },
                                    model: {
                                      value: _vm.searchForm.lat,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.searchForm,
                                          "lat",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "searchForm.lat",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                { attrs: { label: "范围(米)：" } },
                                [
                                  _c("el-input", {
                                    staticStyle: { width: "120px" },
                                    attrs: {
                                      placeholder: "可选",
                                      clearable: "",
                                    },
                                    model: {
                                      value: _vm.searchForm.maxDistance,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.searchForm,
                                          "maxDistance",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "searchForm.maxDistance",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { staticClass: "search-form-sub" },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary", size: "small" },
                                  on: { click: _vm.handleSearch },
                                },
                                [_vm._v("搜索")]
                              ),
                              _c(
                                "el-button",
                                {
                                  staticClass: "ResetSearch",
                                  attrs: { size: "small" },
                                  on: { click: _vm.handleReset },
                                },
                                [_vm._v("重置")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _vm.checkPermi(["platform:lifeVibesPoint:list"])
        ? _c(
            "el-card",
            {
              staticClass: "box-card mt14",
              attrs: {
                "body-style": { padding: "20px" },
                shadow: "never",
                bordered: false,
              },
            },
            [
              _c("div", { staticClass: "acea-row row-between-wrapper mb15" }, [
                _c("div", { staticClass: "header-title" }, [
                  _vm._v("烟火地图点位列表"),
                ]),
                _c(
                  "div",
                  { staticClass: "header-btn" },
                  [
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "hasPermi",
                            rawName: "v-hasPermi",
                            value: ["platform:lifeVibesPoint:save"],
                            expression: "['platform:lifeVibesPoint:save']",
                          },
                        ],
                        attrs: {
                          type: "primary",
                          size: "small",
                          icon: "el-icon-plus",
                        },
                        on: { click: _vm.handleAdd },
                      },
                      [_vm._v(" 新增点位 ")]
                    ),
                  ],
                  1
                ),
              ]),
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.listLoading,
                      expression: "listLoading",
                    },
                  ],
                  ref: "table",
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.tableData.data,
                    size: "mini",
                    height: _vm.tableHeight,
                    "highlight-current-row": "",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "id",
                      label: "ID",
                      width: "70",
                      align: "right",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "点位图片", width: "96", align: "center" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "div",
                                { staticClass: "image-preview" },
                                [
                                  _vm.getFirstImage(scope.row.pointImg)
                                    ? _c("el-image", {
                                        staticClass: "table-image",
                                        attrs: {
                                          src: _vm.getFirstImage(
                                            scope.row.pointImg
                                          ),
                                          "preview-src-list": _vm.getImageList(
                                            scope.row.pointImg
                                          ),
                                          fit: "cover",
                                        },
                                      })
                                    : _c(
                                        "div",
                                        { staticClass: "empty-image" },
                                        [_vm._v("暂无")]
                                      ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3393197233
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "点位",
                      "min-width": "160",
                      prop: "pointName",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "点位类型", width: "110", align: "center" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-tag",
                                {
                                  attrs: {
                                    size: "mini",
                                    type: _vm.getPointTypeTagType(
                                      scope.row.pointType
                                    ),
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.getPointTypeText(
                                          scope.row.pointType
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3293513391
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "认证状态", width: "120", align: "center" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-tag",
                                {
                                  attrs: {
                                    size: "mini",
                                    type: _vm.isCertified(
                                      scope.row.merchantStatus
                                    )
                                      ? "success"
                                      : "info",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.isCertified(
                                          scope.row.merchantStatus
                                        )
                                          ? "已认证/已入驻"
                                          : "未认证/未入驻"
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2701383541
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "所在地区",
                      "min-width": "180",
                      "show-overflow-tooltip": "",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.formatRegion(scope.row) || "-") +
                                  " "
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      395984036
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "详细地点",
                      "min-width": "220",
                      "show-overflow-tooltip": "",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                " " + _vm._s(scope.row.location || "-") + " "
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1383009549
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "标签", "min-width": "180" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm.resolveTags(scope.row.tags).length
                                ? _c(
                                    "div",
                                    { staticClass: "tag-wrap" },
                                    _vm._l(
                                      _vm.resolveTags(scope.row.tags),
                                      function (tag, index) {
                                        return _c(
                                          "el-tag",
                                          {
                                            key: scope.row.id + "-tag-" + index,
                                            attrs: {
                                              size: "mini",
                                              effect: "plain",
                                            },
                                          },
                                          [_vm._v(" " + _vm._s(tag) + " ")]
                                        )
                                      }
                                    ),
                                    1
                                  )
                                : _c("span", [_vm._v("-")]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3736305693
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "浏览数", width: "90", align: "center" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.hasValue(scope.row.readCount)
                                      ? scope.row.readCount
                                      : 0
                                  ) +
                                  " "
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3873069976
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "更新时间",
                      width: "160",
                      prop: "updateTime",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "操作", width: "150", fixed: "right" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "div",
                                { staticClass: "action-buttons" },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text", size: "mini" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleDetail(scope.row)
                                        },
                                      },
                                    },
                                    [_vm._v("详情")]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      directives: [
                                        {
                                          name: "hasPermi",
                                          rawName: "v-hasPermi",
                                          value: [
                                            "platform:lifeVibesPoint:update",
                                          ],
                                          expression:
                                            "['platform:lifeVibesPoint:update']",
                                        },
                                      ],
                                      attrs: { type: "text", size: "mini" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleEdit(scope.row)
                                        },
                                      },
                                    },
                                    [_vm._v(" 编辑 ")]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      directives: [
                                        {
                                          name: "hasPermi",
                                          rawName: "v-hasPermi",
                                          value: [
                                            "platform:lifeVibesPoint:delete",
                                          ],
                                          expression:
                                            "['platform:lifeVibesPoint:delete']",
                                        },
                                      ],
                                      staticClass: "danger-btn",
                                      attrs: { type: "text", size: "mini" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleDelete(scope.row)
                                        },
                                      },
                                    },
                                    [_vm._v(" 删除 ")]
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      703567984
                    ),
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "acea-row row-center-wrapper mt15" },
                [
                  _c("el-pagination", {
                    attrs: {
                      "current-page": _vm.tableFrom.page,
                      "page-size": _vm.tableFrom.limit,
                      "page-sizes": [10, 20, 30, 40],
                      layout: "total, sizes, prev, pager, next, jumper",
                      total: _vm.tableData.total,
                    },
                    on: {
                      "size-change": _vm.handleSizeChange,
                      "current-change": _vm.handleCurrentChange,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-drawer",
        {
          staticClass: "detail-drawer",
          attrs: {
            title: "烟火点位详情",
            visible: _vm.detailDrawerVisible,
            direction: "rtl",
            size: "56%",
            "before-close": _vm.handleDetailClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.detailDrawerVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.detailLoading,
                  expression: "detailLoading",
                },
              ],
              staticClass: "drawer-content",
            },
            [
              _vm.currentDetail
                ? _c(
                    "div",
                    { staticClass: "detail-body" },
                    [
                      _vm.getImageList(_vm.currentDetail.pointImg).length
                        ? _c(
                            "div",
                            { staticClass: "detail-images" },
                            _vm._l(
                              _vm.getImageList(_vm.currentDetail.pointImg),
                              function (image, index) {
                                return _c("el-image", {
                                  key: "detail-image-" + index,
                                  staticClass: "detail-image-item",
                                  attrs: {
                                    src: image,
                                    "preview-src-list": _vm.getImageList(
                                      _vm.currentDetail.pointImg
                                    ),
                                    fit: "cover",
                                  },
                                })
                              }
                            ),
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-descriptions",
                        { attrs: { title: "基础信息", column: 2, border: "" } },
                        [
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "ID" } },
                            [_vm._v(_vm._s(_vm.currentDetail.id))]
                          ),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "点位名称" } },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.currentDetail.pointName || "-") +
                                  " "
                              ),
                            ]
                          ),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "点位类型" } },
                            [
                              _c(
                                "el-tag",
                                {
                                  attrs: {
                                    size: "mini",
                                    type: _vm.getPointTypeTagType(
                                      _vm.currentDetail.pointType
                                    ),
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.getPointTypeText(
                                          _vm.currentDetail.pointType
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "认证状态" } },
                            [
                              _c(
                                "el-tag",
                                {
                                  attrs: {
                                    size: "mini",
                                    type: _vm.isCertified(
                                      _vm.currentDetail.merchantStatus
                                    )
                                      ? "success"
                                      : "info",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.isCertified(
                                          _vm.currentDetail.merchantStatus
                                        )
                                          ? "已认证/已入驻"
                                          : "未认证/未入驻"
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm.getLinkedMarketId(_vm.currentDetail)
                            ? _c(
                                "el-descriptions-item",
                                { attrs: { label: "关联集市ID" } },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.getLinkedMarketId(_vm.currentDetail)
                                      ) +
                                      " "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "浏览数" } },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.hasValue(_vm.currentDetail.readCount)
                                      ? _vm.currentDetail.readCount
                                      : 0
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "简介内容", span: 2 } },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.currentDetail.content || "-") +
                                  " "
                              ),
                            ]
                          ),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "标签", span: 2 } },
                            [
                              _vm.resolveTags(_vm.currentDetail.tags).length
                                ? _c(
                                    "div",
                                    { staticClass: "tag-wrap" },
                                    _vm._l(
                                      _vm.resolveTags(_vm.currentDetail.tags),
                                      function (tag, index) {
                                        return _c(
                                          "el-tag",
                                          {
                                            key: "detail-tag-" + index,
                                            attrs: {
                                              size: "mini",
                                              effect: "plain",
                                            },
                                          },
                                          [_vm._v(" " + _vm._s(tag) + " ")]
                                        )
                                      }
                                    ),
                                    1
                                  )
                                : _c("span", [_vm._v("-")]),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-descriptions",
                        {
                          staticClass: "mt16",
                          attrs: { title: "位置信息", column: 2, border: "" },
                        },
                        [
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "省市区", span: 2 } },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.formatRegion(_vm.currentDetail) || "-"
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "详细地点", span: 2 } },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.currentDetail.location || "-") +
                                  " "
                              ),
                            ]
                          ),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "经度" } },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.hasValue(_vm.currentDetail.lng)
                                      ? _vm.currentDetail.lng
                                      : "-"
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "纬度" } },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.hasValue(_vm.currentDetail.lat)
                                      ? _vm.currentDetail.lat
                                      : "-"
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-descriptions",
                        {
                          staticClass: "mt16",
                          attrs: { title: "时间信息", column: 2, border: "" },
                        },
                        [
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "创建时间" } },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.currentDetail.createTime || "-") +
                                  " "
                              ),
                            ]
                          ),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "更新时间" } },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.currentDetail.updateTime || "-") +
                                  " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _c("div", { staticClass: "no-data" }, [
                    _vm._v("暂无详情数据"),
                  ]),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }